import { Fragment } from "react";

import { Image } from "@/components/image";
import { houseLogo, houseName } from "@/lib/contributor-profile";
import type { OnAirPerson } from "@/lib/episodes";
import { cn } from "@/lib/utils";

const separatorBefore = (index: number, count: number) => {
  if (index === 0) {
    return "";
  }
  return index === count - 1 ? " and " : ", ";
};

export function CrestedName({
  house,
  name,
}: {
  house: string | null;
  name: string;
}) {
  const logo = houseLogo(house);
  return (
    <span className="whitespace-nowrap">
      {logo && (
        <Image
          alt=""
          className="me-1 inline-block size-4 object-contain align-[-0.2em]"
          height={16}
          src={logo}
          width={16}
        />
      )}
      {name}
      {house && <span className="sr-only"> ({houseName(house)})</span>}
    </span>
  );
}

export function HostNames({
  className,
  crests = false,
  hosts,
}: {
  className?: string;
  crests?: boolean;
  hosts: OnAirPerson[];
}) {
  if (hosts.length === 0) {
    return null;
  }
  return (
    <span className={cn("mt-0.5 block text-sm", className)}>
      with{" "}
      {hosts.map((host, index) => (
        <Fragment key={host.id}>
          {separatorBefore(index, hosts.length)}
          {crests ? (
            <CrestedName house={host.house} name={host.firstName} />
          ) : (
            host.firstName
          )}
        </Fragment>
      ))}
    </span>
  );
}
